import { SMSActionTypes, SMSMutationTypes } from './types';
import { notifySuccess } from '../../helpers/notifications';

export const actions = {
    async [SMSActionTypes.GetStatus]({ commit }, { params } = {}) {
        return new Promise((resolve, reject) => {
            this.$api.getSMSStatus.get({
                params: { ...params },
            }).then(response => {
                if (response) {
                    commit(`${SMSMutationTypes.SetStatus}`, { status: response.data?.data?.status })
                    notifySuccess({ title: response.data?.message })
                    resolve(response)
                }
            })
            .catch((error) => {
                reject(error)
            })
        })
    }, 
    async [SMSActionTypes.GetBalance]({ commit }, { params } = {}) {
        return new Promise((resolve, reject) => {
            this.$api.getSMSBalance.get({
                params: { ...params },
            }).then(response => {
                if (response) {
                    commit(`${SMSMutationTypes.SetBalance}`, { balance: response.data?.data?.balance })
                    notifySuccess({ title: response.data?.message })
                    resolve(response)
                }
            })
            .catch((error) => {
                reject(error)
            })
        })
    },    
    async [SMSActionTypes.GetSenders]({ commit }, { params } = {}) {
        return new Promise((resolve, reject) => {
            this.$api.getSMSSenders.get({
                params: { ...params },
            }).then(response => {
                if (response) {
                    commit(`${SMSMutationTypes.SetSenders}`, { senders: response.data?.data?.senders })
                    notifySuccess({ title: response.data?.message })
                    resolve(response)
                }
            })
            .catch((error) => {
                reject(error)
            })
        })
    },    
    async [SMSActionTypes.Send](context, { params } = {}) {
        return new Promise((resolve, reject) => {
            this.$api.sendSMS.get({
                params: { ...params },
            }).then(response => {
                if (response) {
                    notifySuccess({ title: 'SMS отправленно' })
                    resolve(response)
                }
            })
            .catch((error) => {
                reject(error)
            })
        })
    },
}